import type { ReactNode } from 'react';
import { PeoplePage } from '../components/people/PeoplePage';

/**
 * USER-01 at `/admin/users`: People, master and detail (Admin redesign 2026-11-02, People A). The page itself is
 * `PeoplePage`; the person open in the pane is `?person=` in the address.
 */
export function UserListPage(): ReactNode {
  return <PeoplePage />;
}
